module.exports = __webpack_public_path__ + "img/104.26ab9558.png";